import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import {
  emptyFleetFilterSelection,
  FLEET_FILTER_PARAMETERS,
  type FleetFilterParameter,
  type FleetFilterState,
} from './fleetFilter.types';

interface ValuePayload {
  parameter: FleetFilterParameter;
  value: string;
}

export const fleetFilterSlice = createSlice({
  name: 'aviationTimeline/fleetFilter',
  initialState: (): FleetFilterState => ({
    selected: emptyFleetFilterSelection(),
  }),
  reducers: {
    valueToggled: (state, { payload }: PayloadAction<ValuePayload>) => {
      const values = state.selected[payload.parameter];
      const at = values.indexOf(payload.value);

      if (at === -1) {
        values.push(payload.value);
      } else {
        values.splice(at, 1);
      }
    },
    valueRemoved: (state, { payload }: PayloadAction<ValuePayload>) => {
      state.selected[payload.parameter] = state.selected[
        payload.parameter
      ].filter(value => value !== payload.value);
    },
    // AC5: every parameter, not just the one last touched.
    filterCleared: state => {
      for (const parameter of FLEET_FILTER_PARAMETERS) {
        state.selected[parameter] = [];
      }
    },
  },
});

export const fleetFilterActions = fleetFilterSlice.actions;
